import analytics from '@banking/ui/workflows/utils/analytics';
import events from '@banking/ui/workflows/card-settings/billing-address/analytics/billing-address-events';
export default analytics([...events]);